import React, { useState } from 'react';
import './Contact.css';
import { Circles } from 'react-loader-spinner';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebook, FaTwitter, FaInstagram, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  const [mapLoading, setMapLoading] = useState(true);

  return (
    <div className="contact">
      <div className="contact-wrapper">
        <h2 className="contact-section-title">📞 Contact Us</h2>
        <p className="contact-intro">
          We’re here to serve you.<br />
          Whether you’re a resident with questions, a business looking to collaborate, or a development partner interested in working with us — the Igbo-Eze North Local Government Council welcomes your engagement.
        </p>

        <div className="contact-grid">
          <div className="contact-info">
            <h3>📍 Main Secretariat</h3>
            <p><FaMapMarkerAlt /> Igbo-Eze North Local Government Council<br />Council Headquarters, Ogrute, Enugu State, Nigeria</p>

            <h3>🕒 Office Hours</h3>
            <p><FaClock /> Monday – Friday, 8:00 AM – 4:00 PM (WAT)<br />(Closed on weekends and public holidays)</p>

            <h3>📱 Contact Numbers</h3>
            <p><FaPhone /> Main Line: +234 701 234 5678</p>
            {/* <p><FaPhone /> Development Centre Desk: +234 701 234 5678</p> */}
            <p><FaPhone /> Security & Emergency Line: +234 809 876 5432</p>

            <h3>📧 Email</h3>
            <p><FaEnvelope /> General: info@igboezenorth.en.gov.ng</p>
            <p><FaEnvelope /> Procurement/Bids: procurement@igboezenorth.en.gov.ng</p>
            <p><FaEnvelope /> Public Relations: outreach@igboezenorth.en.gov.ng</p>

            <h3>💬 Connect With Us Online</h3>
            <div className="social-icons">
              <a href="https://www.facebook.com/share/15ZVSBn3xa" aria-label="Facebook"><FaFacebook /></a>
              <a href="https://x.com/igboezenorthlga" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://whatsapp.com/channel/0029VaGoHhC3GJP4NAB6Rt1X" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
            </div>
          </div>

          <form className="contact-form">
            <h3>📩 Contact Form</h3>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <input type="tel" placeholder="Your Phone Number" />
            <input type="text" placeholder="Subject" required />
            <textarea placeholder="Your Message" rows="5" required></textarea>
            <button type="submit">Send Message</button>
            <p className="form-note">We aim to respond to all inquiries within 2–3 business days.</p>
          </form>
        </div>

        <div className="contact-map">
          <h3>🗺️ Our Location</h3>
          {mapLoading && (
            <div style={{ display: 'flex', columnGap: '10px', alignItems: 'center', justifyContent: 'center', height: '200px', color: 'gray' }}>
                    <Circles height="50" width="50" color="#008751" ariaLabel="loading" /> <h2>Loading Map...</h2>
                  </div>
          )}
          <iframe
            title="Igbo-Eze North Location Map"
            src="https://www.google.com/maps?q=XFM4%2B4MQ+Enugu-Ezike&output=embed"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            onLoad={() => setMapLoading(false)}
          />
        </div>

        <div className="closing-message">
          <p>🤝 Let’s build Igbo-Eze North together.<br />Your ideas, feedback, and participation matter.</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;